import * as React from "react";
import { useState, useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import useFeature from "hooks/useFeature";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { Input, Button } from "components/bootstrap";
import { useAddEvidence, useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import { isPermitted } from "util/PermissionsMixin";
import EventsList from "./EventsList";
import { Row, FormGroup } from "../styled.components";
function Events({ investigation }) {
  const { permissions } = useCurrentUser();
  const [newEventId, setNewEventId] = useState("");
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteEventId, setDeleteEventId] = useState(null);
  const isRightSidebarEnabled = useFeature("investigation_right_sidebar");
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted(permissions, "investigations:edit"),
    [investigation.archived, permissions]
  );
  const showAddForm = canManageEvidence && !isRightSidebarEnabled;
  const { addEvidence } = useAddEvidence();
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const isFormValid = useMemo(() => newEventId && newEventId.replace(/\s/g, "").length > 0, [newEventId]);
  const onAddEvent = async (e) => {
    e.preventDefault();
    if (isFormValid) {
      await addEvidence({ invId: investigation.id, payload: { events: [newEventId] } });
    }
    setNewEventId("");
  };
  const removeEvent = async () => {
    await removeEvidence({ invId: investigation.id, payload: { events: [deleteEventId] } });
    setShowDeleteDialog(false);
    setDeleteEventId(null);
  };
  const onDelete = (eventId) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteEventId(eventId);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteEventId(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showAddForm && /* @__PURE__ */ React.createElement("form", { onSubmit: onAddEvent }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "add-event-id",
      type: "text",
      label: "Add Event",
      "data-testid": "add-event-id",
      autoComplete: "off",
      placeholder: "Enter event ID",
      value: newEventId,
      onChange: (e) => setNewEventId(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", onClick: onAddEvent, disabled: !isFormValid }, "Add"))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    EventsList,
    {
      key: investigation.id,
      investigation,
      canManageEvidence,
      onDelete
    }
  )), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: "Delete Event",
      onConfirm: removeEvent,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    "Are you sure you want to delete this Event?"
  ));
}
export default Events;
